package com.devsusana.portfolio.components.widgets

import androidx.compose.runtime.Composable
import com.devsusana.portfolio.styles.SitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

/**
 * A pill badge displaying a skill or technology tag.
 */
@Composable
fun TechBadge(
    text: String,
    modifier: Modifier = Modifier,
    highlight: Boolean = false
) {
    val colorMode = ColorMode.current
    val bgColor = if (highlight) {
        Color.rgba(61, 220, 132, 0.15f) // Subtle Android green
    } else {
        if (colorMode.isDark) Color.rgba(255, 255, 255, 0.08f) else Color.rgba(0, 0, 0, 0.05f)
    }

    val textColor = if (highlight) {
        SitePalette.androidGreen
    } else {
        SitePalette.textSecondary(colorMode)
    }

    Box(
        modifier = modifier
            .backgroundColor(bgColor)
            .borderRadius(999.px)
            .padding(leftRight = 0.75.cssRem, topBottom = 0.25.cssRem)
            .border(
                width = 1.px,
                style = org.jetbrains.compose.web.css.LineStyle.Solid,
                color = if (highlight) SitePalette.androidGreen else SitePalette.surfaceBorder(colorMode)
            )
    ) {
        SpanText(
            text = text,
            modifier = Modifier
                .color(textColor)
                .fontSize(0.85.cssRem)
                .fontWeight(FontWeight.SemiBold)
        )
    }
}
